import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const gsDivStartsWith = async (data) => {
  try {
    let search = "";
    let params = {};
    if (typeof data === "object" && data !== null) {
      search = data.searchText || "";
      if (data.companyId) {
        params.companyId = data.companyId;
      } else if (data.rgsComId) {
        params.companyId = data.rgsComId;
      }
    } else {
      search = data || "";
    }

    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/gsView/namestartswith`,
      search,
      { params }
    );

    return (response.data || []).map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const gsDivisionNameById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/gsView/name/${id}`,
    );
    console.log(response.data);
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};
